document.querySelectorAll('.form-label-input[data-bind-js]').forEach(el => {
    bindLabelInput(el)
})

function toogleShrinkPlaceholder(el, value) {
    if (value) {
        el.classList.add('shrink-placeholder')
    } else {
        el.classList.remove('shrink-placeholder')
    }
}

/**
 * @param {HTMLElement} el
 */
export function bindLabelInput(el) {
    let input = el.querySelector('input.form-control')

    if (input) {
        input.addEventListener('change', function(event) {
            toogleShrinkPlaceholder(el, event.target.value.length)
        })

        toogleShrinkPlaceholder(el, input.value)

        return
    }

    input = el.querySelector('select.choices__input')

    input.addEventListener('change', function(event) {
        toogleShrinkPlaceholder(el, event.target.selectedOptions.length)
    })

    toogleShrinkPlaceholder(el, input.selectedOptions.length)
}

export function bindAllLabelInput() {
    document.querySelectorAll('.form-label-input').forEach(el => {
        bindLabelInput(el)
    })
}

